import { MapV2ModalLayoutMobile } from 'components/mapV2/MapV2Modal/layout/generic/MapV2ModalLayoutMobile';
import { MapV2ModalDetail } from 'components/mapV2/MapV2Modal/MapV2ModalDetail';
import { MapV2ModalList } from 'components/mapV2/MapV2Modal/MapV2ModalList';
import { FFullMoment } from 'graphql/fragment/__generated__/FFullMoment';
import { WorldMapMarkerStory_worldMapView_markers } from 'graphql/query/__generated__/WorldMapMarkerStory';
import { useContext, useState } from 'react';
import { CtxModal } from 'session/ctxModal';
import styled from 'styled-components/macro';

interface Props {
    className?: string;
    storiesList: FFullMoment[];
    marker: WorldMapMarkerStory_worldMapView_markers | null;
}

export const MapV2WithoutListMobile = (props: Props): JSX.Element => {
    const ctxModal = useContext(CtxModal);

    const [height, setHeight] = useState<string>('0px');

    return (
        <MapV2ModalLayoutMobile
            onMaxSnapSizeChanged={(height) => {
                setHeight(height);
            }}
        >
            {ctxModal.detailListModal && !ctxModal.detailModal?.detail && (
                <S_MapV2ModalList stories={props.storiesList} height={height} withoutHeader />
            )}
            {ctxModal.detailModal?.detail && (
                <S_MapV2ModalDetail
                    story={ctxModal.detailModal.detail}
                    marker={props.marker}
                    height={height}
                />
            )}
        </MapV2ModalLayoutMobile>
    );
};

const S_MapV2ModalDetail = styled(MapV2ModalDetail)`
    width: 100vw;
`;

const S_MapV2ModalList = styled(MapV2ModalList)`
    width: 100vw;
`;
